import { Component } from '@angular/core';
import { StudentNav } from '../../../common/student-nav/student-nav';
import { MessagesThreadPage } from '../../../common/messages-thread-page/messages-thread-page';

/**
 * Thin shell for the student Messages route — renders the student nav and
 * this role's page-level layout, then embeds the shared thread/composer
 * component that both roles use identically.
 */
@Component({
  selector: 'app-student-messages-page',
  standalone: true,
  imports: [StudentNav, MessagesThreadPage],
  templateUrl: './student-messages-page.html',
  styleUrls: ['./student-messages-page.css'],
})
export class StudentMessagesPage {}
